import { Stack } from '@mui/material';
import OrderLimitsCalendar from 'components/kitchen-capacity/order-limits-calendar/order-limits-calendar.component';

const OrderLimits = () => {
  return (
    <Stack direction="column" spacing={2} mt={2}>
      <OrderLimitsCalendar />
    </Stack>
  );
};

export default OrderLimits;
